// Fixed app title/subtitle. Logo + favicon are admin-configurable (fetched).
export const APP_TITLE = "LOAD STUDIOS";
export const APP_SUBTITLE = "ADS DASHBOARD";

export interface Branding {
  /** Data URI of the app logo, or null for the default "L" mark. */
  logo: string | null;
  /** Data URI of the favicon, or null for the browser default. */
  favicon: string | null;
  title: string;
  subtitle: string;
}
